/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { getCollapsedDrawerSections } from 'selectors';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction } from 'types';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import {
  getSidebarValues,
  setSidebarValues,
} from 'util/application-storage/sidebar';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

// Types
interface Collapsible {
  open: boolean;
}
export interface CollapsiblesState {
  [key: string]: Collapsible;
}

// Initial state
function getCollapsedFromLocalStorage() {
  const sidebar = getSidebarValues();
  if (sidebar && sidebar.collapsedDrawerSections) {
    return sidebar.collapsedDrawerSections.reduce((prev, sectionId) => {
      return {
        ...prev,
        [sectionId]: {
          open: false,
        },
      };
    }, {});
  }
}

const initialState: CollapsiblesState = {
  ...getCollapsedFromLocalStorage(),
};

// Action types
const TOGGLE_COLLAPSIBLE = Symbol('ui/TOGGLE_COLLAPSIBLE');

// Reducer
export default createReducer(initialState, {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [TOGGLE_COLLAPSIBLE](state: CollapsiblesState, { payload }: any) {
    const { id, open } = payload;

    return {
      ...state,
      [id]: {
        open: state[id] ? !state[id].open : !open,
      },
    };
  },
});

// Side effects
const updateLocalStorage = (state: CollapsiblesState) => {
  const localStorageValues = getSidebarValues();
  if (localStorageValues) {
    const collapsedSections = state ? Object.keys(state) : [];
    const localStorageUpdate = {
      ...localStorageValues,
      collapsedDrawerSections: collapsedSections.filter(
        (section) => !state[section].open,
      ),
    };
    setSidebarValues(localStorageUpdate);
  }
};

// Action creators
const toggleCollapsibleAction = actionCreator(TOGGLE_COLLAPSIBLE);

// Actions
export const toggleCollapsible = (
  collapsibles: CollapsiblesState,
): StandardThunkAction => {
  return async (dispatch, getState) => {
    dispatch(toggleCollapsibleAction(collapsibles));

    updateLocalStorage(getCollapsedDrawerSections(getState()));
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/collapsibles.ts